import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { blocks } from '../data/newsData';
import './VillageDetail.css';

function VillageDetail() {
  const { villageId } = useParams();

  // Find the village from all blocks
  let village = null;
  let block = null;

  for (const b of blocks) {
    const v = b.villages.find(v => v.id === parseInt(villageId));
    if (v) {
      village = v;
      block = b;
      break;
    }
  }

  if (!village || !block) {
    return (
      <div className="village-detail">
        <div className="container">
          <div className="not-found">
            <h2>गाँव नहीं मिला</h2>
            <p>आप जिस गाँव को खोज रहे हैं वह नहीं मिल सका।</p>
            <Link to="/blocks" className="back-link">अभी वापस जाएं</Link>
          </div>
        </div>
      </div>
    );
  }

  const villageIndex = block.villages.findIndex(v => v.id === parseInt(villageId));
  const prevVillage = villageIndex > 0 ? block.villages[villageIndex - 1] : null;
  const nextVillage = villageIndex < block.villages.length - 1 ? block.villages[villageIndex + 1] : null;

  return (
    <div className="village-detail">
      {/* Header with Image */}
      <section className="village-hero">
        <img src={village.image} alt={village.name} className="hero-image" />
        <div className="hero-overlay">
          <div className="container">
            <Link to="/blocks" className="back-btn">← वापस</Link>
            <div className="hero-content">
              <h1>{village.name}</h1>
              <p className="breadcrumb">
                {block.name} / {village.name}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="village-content-section">
        <div className="container">
          <div className="village-layout">
            {/* Main Content */}
            <div className="village-main">
              {/* Quick Stats */}
              <div className="quick-stats">
                <div className="stat-card">
                  <div className="stat-icon">👥</div>
                  <div className="stat-info">
                    <p>जनसंख्या</p>
                    <h3>{village.population}</h3>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">📍</div>
                  <div className="stat-info">
                    <p>क्षेत्रफल</p>
                    <h3>{village.area}</h3>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">🏛️</div>
                  <div className="stat-info">
                    <p>ब्लॉक</p>
                    <h3>{block.name}</h3>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">🛠️</div>
                  <div className="stat-info">
                    <p>सुविधाएं</p>
                    <h3>{village.facilities.length} +</h3>
                  </div>
                </div>
              </div>

              {/* Description */}
              <div className="info-section">
                <h2>📋 विवरण</h2>
                <p className="description-text">{village.details}</p>
              </div>

              {/* Facilities */}
              <div className="facilities-section">
                <h2>🏢 उपलब्ध सुविधाएं</h2>
                <div className="facilities-grid">
                  {village.facilities.map((facility, idx) => (
                    <div key={idx} className="facility-card">
                      <div className="facility-icon">✓</div>
                      <p>{facility}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Navigation */}
              <div className="village-navigation">
                {prevVillage && (
                  <Link to={`/village/${prevVillage.id}`} className="nav-link prev">
                    <span>← पिछला गाँव</span>
                    <span className="nav-title">{prevVillage.name}</span>
                  </Link>
                )}
                <Link to="/blocks" className="nav-link center">
                  <span>सभी गाँव देखें</span>
                </Link>
                {nextVillage && (
                  <Link to={`/village/${nextVillage.id}`} className="nav-link next">
                    <span>अगला गाँव →</span>
                    <span className="nav-title">{nextVillage.name}</span>
                  </Link>
                )}
              </div>
            </div>

            {/* Sidebar */}
            <div className="village-sidebar">
              {/* Block Info Card */}
              <div className="sidebar-card block-info">
                <h3>ब्लॉक की जानकारी</h3>
                <div className="block-info-content">
                  <img src={block.image} alt={block.name} />
                  <h4>{block.name}</h4>
                  <p>{block.description}</p>
                  <div className="block-stats">
                    <div>
                      <span>जनसंख्या</span>
                      <strong>{block.population}</strong>
                    </div>
                    <div>
                      <span>क्षेत्रफल</span>
                      <strong>{block.area}</strong>
                    </div>
                    <div>
                      <span>गाँव</span>
                      <strong>{block.villages.length}</strong>
                    </div>
                  </div>
                </div>
                <Link to="/blocks" className="view-block-btn">पूरा ब्लॉक देखें</Link>
              </div>

              {/* Other Villages in Block */}
              <div className="sidebar-card other-villages">
                <h3>इसी ब्लॉक के अन्य गाँव</h3>
                <div className="other-villages-list">
                  {block.villages.map(v => (
                    <Link
                      key={v.id}
                      to={`/village/${v.id}`}
                      className={`other-village-item ${v.id === village.id ? 'current' : ''}`}
                    >
                      <span className="village-name">{v.name}</span>
                      <span className="village-pop">{v.population}</span>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Share Section */}
              <div className="sidebar-card share-section">
                <h3>साझा करें</h3>
                <button className="share-btn facebook">Facebook</button>
                <button className="share-btn twitter">Twitter</button>
                <button className="share-btn whatsapp">WhatsApp</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default VillageDetail;
